/* src/app/modules/portal/components/lastDataSourceRefresh/lastDataSourceRefreshStatus/linkToXmart/linkToXmart.component.css */
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.link:hover {
  color: #ec6602;
  cursor: pointer;
}
/*# sourceMappingURL=linkToXmart.component.css.map */
